"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NETWORK_STATUS = exports.ENVIRONMENTS = exports.DEVICES = void 0;
// DEPRECATED NOW UTILS.CONSTANTS
var DEVICES = {
  MOBILE: 'mobile',
  PC: 'pc',
  TABLET: 'tablet'
};
exports.DEVICES = DEVICES;
var ENVIRONMENTS = {
  QA: 'qa',
  DEV: 'dev',
  PROD: 'prod'
};
exports.ENVIRONMENTS = ENVIRONMENTS;
var NETWORK_STATUS = {
  FETCHING: 'fetching',
  SUCCESS: 'success',
  ERROR: 'error'
};
exports.NETWORK_STATUS = NETWORK_STATUS;

//# sourceMappingURL=index.js.map